import { tCasesLib } from '@/Interfaces/casesLib';

//TODO xmlId
export const casesLib: tCasesLib = [
    {
        id: 'tc_1095',
        xmlId: '93e0678f-20e3-1511-37d7-5fb91e2539a0',
        name: 'Шкаф инструментальный TC-1095',
        categoryId: '1b4e5141-bd5f-4736-8a91-8f9c53449580',
        key: 'TC-1095',
        minPrice: '28600',
        props: [
            '1000x950x500',
            'Регулируемые полки',
            'До 250 кг',
            'Сборно-разборный',
        ],
        blenderName: 'tc_1095',
        image: 'dist/src/img/1095.jpg',
    },
    {
        id: 'tc_1995',
        xmlId: '7b250ab2-fdd0-b04b-2d40-aa7b700f1b2a',
        name: 'Шкаф инструментальный TC-1995',
        categoryId: '1b4e5141-bd5f-4736-8a91-8f9c53449580',
        key: 'TC-1995',
        minPrice: '28600',
        props: [
            '1900x950x500',
            'Регулируемые полки',
            'До 500 кг',
            'Сборно-разборный',
        ],
        blenderName: 'tc_1995',
        image: 'dist/src/img/1995.jpg',
    },
    {
        id: 'tc_1995_2',
        xmlId: '5ab4e54a-e50c-5b3f-9a26-4e3d80f98142',
        name: 'Шкаф инструментальный TC-1995/2',
        categoryId: '1b4e5141-bd5f-4736-8a91-8f9c53449580',
        key: 'TC-1995-2',
        minPrice: '28600',
        props: [
            '1900x950x500',
            'Регулируемые полки',
            'До 500 кг',
            'Сборно-разборный',
        ],
        blenderName: 'tc_1995_2',
        image: 'dist/src/img/1995-2.jpg',
    },
    {
        id: 'tc_1947',
        xmlId: 'c725f1fa-8ea6-8f37-87f2-582393c2b931',
        name: 'Шкаф инструментальный TC-1947',
        categoryId: '1b4e5141-bd5f-4736-8a91-8f9c53449580',
        key: 'TC-1947',
        minPrice: '28600',
        props: [
            '1900x475x500',
            'Регулируемые полки',
            'До 200 кг',
            'Сборно-разборный',
        ],
        blenderName: 'tc_1947',
        image: 'dist/src/img/1947.jpg',
    },
    {
        id: 'amh_tc',
        xmlId: '994041c2-b65c-7775-38bf-519f10bad3ae',
        name: 'Шкаф инструментальный тяжелый AMH TC',
        categoryId: 'b391fb8e-d0c0-4549-978d-fa37650d0298',
        key: 'AMH-TC',
        minPrice: '28600',
        props: [
            '1850x920x460',
            'Механический замок',
            'До 1000 кг',
            'Поставляются в собранном виде',
        ],
        blenderName: 'amh_tc',
        image: 'dist/src/img/AMH.jpg',
    },
    {
        id: 'amh_tc_el',
        xmlId: '7eed3c57-3a3c-ec57-fa69-e453c6296b41',
        name: 'Шкаф инструментальный тяжелый AMH TC EL',
        categoryId: 'b391fb8e-d0c0-4549-978d-fa37650d0298',
        key: 'AMH-TC-EL',
        minPrice: '28600',
        props: [
            '1850x920x460',
            'Электоронный замок',
            'До 1000 кг',
            'Поставляются в собранном виде',
        ],
        blenderName: 'amh_tc_el',
        image: 'dist/src/img/AMH_TC_EL.jpg',
    },
    {
        id: 'hard_1000',
        xmlId: '5ab7e57a-e50c-5b3f-9a26-7e3d80f98172',
        name: 'Инструментальный шкаф HARD 1000',
        categoryId: 'f5020fc9-0e74-44b9-91c5-6470f3012636',
        key: 'HARD-1000',
        minPrice: '28600',
        props: [
            '998x1150x650',
            'Регулируемые полки',
            'До 1000 кг',
            'Сборно-разборный',
        ],
        blenderName: 'hard_1000',
        image: 'dist/src/img/hard1000.jpg',
    },
    {
        id: 'hard_2000',
        xmlId: 'a596e449-da39-1d5c-3a0d-b87a41c96137',
        name: 'Инструментальный шкаф HARD 2000',
        categoryId: 'f5020fc9-0e74-44b9-91c5-6470f3012636',
        key: 'HARD-2000',
        minPrice: '28600',
        props: [
            '1998x1150x650',
            'Регулируемые полки',
            'До 2000 кг',
            'Сборно-разборный',
        ],
        blenderName: 'hard_2000',
        image: 'dist/src/img/hard2000.jpg',
    },
];
